<template>
	<div class="Ccon">
		<div id="container"></div>

		<!-- 氛围遮罩 -->
		<div class="vignette vignette-top"></div>
		<div class="vignette vignette-bottom"></div>

		<!-- 顶部行程进度 -->
		<div class="journey-header" v-if="cityList.length">
			<div class="journey-title">
				<span class="journey-icon">✈</span>
				<span>旅行轨迹回放</span>
			</div>
			<div class="journey-progress">
				<div
					v-for="(item, i) in cityList"
					:key="i"
					class="progress-node"
					:class="{ active: i === pathIndex, done: i < pathIndex }"
				>
					<div class="node-dot"></div>
					<div class="node-name">{{ i <= pathIndex ? item.startCity.name : '?' }}</div>
					<div class="node-line" v-if="i < cityList.length - 1"></div>
				</div>
				<div class="progress-node" :class="{ done: pathIndex >= cityList.length }">
					<div class="node-dot end"></div>
					<div class="node-name">{{ pathIndex >= cityList.length ? cityList[cityList.length - 1].endCity.name : '?' }}</div>
				</div>
			</div>
		</div>

		<!-- 左下角当前行程卡片 -->
		<transition name="card-fade" mode="out-in">
			<div class="trip-card" v-if="currentSegment && isPlay" :key="pathIndex">
				<div class="trip-card-tag">第 {{ pathIndex + 1 }} / {{ cityList.length }} 段</div>
				<div class="trip-route">
					<span class="trip-city">{{ currentSegment.startCity.name }}</span>
					<span class="trip-arrow">
						<i></i>
					</span>
					<span class="trip-city trip-dest">?</span>
				</div>
				<div class="trip-meta">
					<span class="trip-distance">约 {{ currentDistance }}</span>
					<span class="trip-live"><i class="live-dot"></i>回放中</span>
				</div>
			</div>
		</transition>

		<!-- 加载失败提示 -->
		<div class="track-error" v-if="trackError">
			<div class="error-box">行程数据加载失败，请稍后重试</div>
		</div>

		<!-- 到达城市提示 -->
		<transition name="arrive-pop">
			<div class="arrive-toast" v-if="arriveName">📍 已抵达 {{ arriveName }}</div>
		</transition>

		<showImg3  :imgList="imgList" v-if="isShow" @close="imgClose"></showImg3>

		<!-- 地球→地图 云层掀开过渡特效 -->
		<div class="cloud-wipe" v-if="isWarping">
			<div class="cloud-piece cloud-c"></div>
			<div class="cloud-piece cloud-tl"></div>
			<div class="cloud-piece cloud-tr"></div>
			<div class="cloud-piece cloud-bl"></div>
			<div class="cloud-piece cloud-br"></div>
		</div>

		<!-- 地球旋转开场动画 -->
		<transition name="globe-fade">
			<div class="globe-intro" v-if="showGlobe">
				<canvas id="globeCanvas"></canvas>
				<div class="globe-vignette"></div>
				<div class="globe-hud">
					<div class="hud-corner hc-tl"></div>
					<div class="hud-corner hc-tr"></div>
					<div class="hud-corner hc-bl"></div>
					<div class="hud-corner hc-br"></div>
					<div class="globe-hud-top">ORBITAL VIEW <b>· LIVE</b></div>
					<div class="globe-hud-status" v-html="globeStatus"></div>
					<div class="globe-hud-coord">{{ globeCoord }}</div>
				</div>
				<!-- <div class="globe-skip" @click="skipGlobe">跳过 SKIP</div> -->
			</div>
		</transition>

	</div>

</template>

<script>
	// import {LabelCluster} from "m"
	import axios  from "axios"
	import { isFinite } from 'core-js/core/number'
	import showImg3 from '../components/showImg3.vue'
	import showImg from '../components/showImg.vue'
	import showImg2 from "../components/showImg2.vue"
import {
		imgList
	} from '../utils/tools'
	import { baseUrl,mapKey } from '../utils/api'
	import request from "../utils/request.js"
	
	import Point from "@/assets/point.png"
	import EarthTex from "@/assets/earth.jpg"
	export default {
		name: 'index',
		components:{showImg3,showImg,showImg2},
		data() {
			return {
				map: null,isShow:false,imgList:null,
				position: null,cityList:[],markerLabel:null,
				roation: null,allPoint:[],videoLoading:false,
				marker: null,isPlay:false,
				trail: null,trails:[],pathIndex:0,
				markerData: [],
				trailData: [],
				path: [],pathParam:null,videoUrl:'',
				center: {
					latitude: 40.040523,
					longitude: 116.273654
				},
				durationTime:6,
				speed:0,
				segDistance:0,
				trackError:false,
				arriveName:'',
				showGlobe:true,
				globeStatus:'正在初始化轨道参数…',
				globeCoord:'ALT 35786 KM · GEO',
				isWarping:false,
				id:'6a5f389265234199739b639f',
				// 6a2eb50a3f1a473b2cbd6836
				// 689bff11189f86d5e18bfc09
				// 68940aa0c3b5c9ccb0282517

			}
		},
		computed:{
			mapZoom(){
				// 速度(m/s) -> zoom 映射：长距离保持视野完整，短距离贴地沉浸
				const ranges = [
					{min:0,max:15,level:17},
					{min:15,max:40,level:16.5},
					{min:40,max:100,level:16},
					{min:100,max:250,level:15},
					{min:250,max:600,level:14},
					{min:600,max:1500,level:13},
					{min:1500,max:4000,level:12},
					{min:4000,max:10000,level:10.5},
					{min:10000,max:25000,level:9},
					{min:25000,max:60000,level:8},
					{min:60000,max:150000,level:7},
					{min:150000,max:Infinity,level:6},
				]
				let spd = ranges.find(range=>this.speed>=range.min&&this.speed<range.max)
				return spd ? spd.level : 10
			},
			currentSegment(){
				if(!this.cityList.length || this.pathIndex >= this.cityList.length) return null
				return this.cityList[this.pathIndex]
			},
			currentDistance(){
				if(!this.segDistance) return '--'
				let km = this.segDistance / 1000
				return km >= 100 ? Math.round(km) + ' km' : km.toFixed(1) + ' km'
			}
		},
		watch: {
			// videoUrl(val) {
			// 	if (val && !this.isPlay) {
			// 		this.backToMiniProgram()
			// 	}
			// },
			// isPlay(val){
			// 	if (val&&!this.videoUrl) {
			// 		this.showLoading()
			// 	}
			// }

		},
		mounted() {
			// this.initMap()
			this.videoUrl =''
			// 提前加载 three.js，与轨迹数据请求并行，缩短开场等待
			this.loadThree().catch(() => {})
			this.getUrlParams()
			// this.getVideo()
		    // this.initPoint()
			
			// setTimeout(()=>{
			// 	this.startMove()
			// },1000)
			
		},
		beforeDestroy() {
			// 页面销毁时清理所有轨迹图层
			this.trails.forEach(t => t.remove && t.remove())
			this.trails = []
			// 清理地球开场动画资源
			if (this._globe) {
				this._globe.stop()
				this._globe.dispose()
				this._globe = null
			}
		},
		methods: {
			showLoading(){

			},
			backToMiniProgram() {
				console.log('跳转小程序中间页，携带 videoUrl:', this.videoUrl)
				const url = `/pages/downVideo/downVideo?id=${encodeURIComponent(this.id)}`
				if (window.wx && window.wx.miniProgram) {
					window.wx.miniProgram.navigateTo({ url })
				} else if (window.tt && window.tt.miniProgram) {
					window.tt.miniProgram.navigateTo({ url })
				}
			},
			async getVideo(){
				if (this.videoLoading) return
				this.videoLoading = true
				console.log('生成视频:', this.id)
				try {
					// let url ='http://127.0.0.1:8000/api/task/create-from-track'
					let url ='https://tripmp.com/api/task/create-from-track'
					const res = await request.post(url,{
						// "track_id": "68940aa0c3b5c9ccb0282517",
						"track_id": this.id,
					})
					console.log('视频生成完成:', res)
					if (res.video_url) {
						console.log('视频地址:', res.video_url)
						// videoUrl = "https://tripmp.com/outputs/604d37c8-64e6-4148-a02a-14e0d747fd9c.mp4"
						this.videoUrl = 'https://tripmp.com' + res.video_url
						this.videoLoading = false
						}
				} catch(err) {
					console.error('请求失败:', err)
				}
			},
			async getLine(){
				let param = this.cityList[this.pathIndex]
				let start = param.startCity.latitude+","+param.startCity.longitude
				let end = param.endCity.latitude+","+param.endCity.longitude
				let baseUrl = "/tencent-map/ws/direction/v1/driving/?"
				let url = `${baseUrl}from=${start}&to=${end}&key=${mapKey}`
				
				return new Promise((resolve) => {
					request(url).then(res=>{
						const consp = res.result.routes[0]
						let route = consp.polyline
						for (var i = 2; i < route.length ; i++){
							route[i] = route[i-2] + route[i]/1000000
						}
						let arr = this.dealPolyline(route)
						console.log("路线")
						console.log(arr)
						arr.forEach(i=>{
							this.markerData.push(new TMap.LatLng(i.lat, i.lng))
						})
						this.trailData.push({
							path: this.path,
						})
						console.log("markerData")
						console.log(this.markerData)
						resolve()
					}).catch(err => {
						console.error('路线请求失败，使用原始轨迹点兜底', err)
						// 降级：用接口返回的原始 path 点
						param.path.forEach(p => {
							this.markerData.push(new TMap.LatLng(p.latitude, p.longitude))
							this.path.push([p.latitude, p.longitude])
						})
						this.trailData.push({
							path: this.path,
						})
						resolve()
					})
				})
			},
			dealPolyline(coords){
				let point = []
				let len = coords.length
				let index = 0
				let ide = Math.floor(len/100)
				let qwe = ide % 2 === 0 ? ide : ide - 1;
				while(index<len){
					// 增加越界判断，避免 undefined 错误
					if (index + 1 >= len) break;
					
					this.path.push([coords[index], coords[index+1]])
					// let param = {
					// 	latitude:coords[index],
					// 	longitude:coords[index+1]
					// }
					// point.push(param)
					point.push(new TMap.LatLng(coords[index], coords[index+1]))
					if(len<100){
						index+=2
					}else{
						index+=qwe
					}
				}
				
				// this.trailData.push({
				// 	path: this.path,
				// })
				
				return point
				
			},
			addDisPoint(posi){
				console.log('addDisPoint', posi)
			},
			createBackendVideo() {
				this.videoLoading = true   // 按钮显示"生成视频中"
				axios.post('https://tripmp.com/api/task/create-from-track', { track_id: this.id })
					.then(res => {
						this.videoLoading = false
						const videoUrl = 'https://tripmp.com' + res.data.video_url
						
						window.open(videoUrl)  // 新窗口打开下载/播放
					})
			},
			async getTrack(retryCount = 0){
				let id = this.id
				let url = `${baseUrl}/upload_track/getTrack?id=${id}`
				try {
					let res = await request(url)
					let data = res.data[0]
				    this.cityList = JSON.parse(data.path)
					this.initMap()
				this.$nextTick(() => {
					// 先播放地球旋转开场，结束后再开始轨迹回放
					this.playGlobeIntro()
				})
				} catch(err) {
					console.error('轨迹数据获取失败', err)
					if (retryCount < 3) {
						setTimeout(() => {
							this.getTrack(retryCount + 1)
						}, 1500)
					} else {
						this.trackError = true
					}
				}
			},
			getUrlParams(){
				let param = this.$route.query
				this.isPlay = true
				if(param.id){
					this.id = param.id
					this.getTrack()
					
				}else{
					this.getTrack()
				}
				
			},
			imgClose(){
				this.isShow = false
				this.pathIndex++
				if(this.pathIndex==this.cityList.length){
					this.setAllpoint()
				}else{
					this.startMove()
				}
				
			},
			showArriveToast(name){
				this.arriveName = name
				setTimeout(()=>{
					this.arriveName = ''
				}, 2200)
			},
			zoomOutToCity(city){
				if(!this.map) return
				this.map.easeTo({
					center: new TMap.LatLng(city.latitude, city.longitude),
					zoom: 12,
					pitch: 0,
					rotation: 0,
				}, {
					duration: 1200,
				})
			},
			async startMove(){
				let len = this.cityList.length
				if(len==this.pathIndex){
					return
				}
				let param = this.cityList[this.pathIndex]
				// this.durationTime = param.duration
				
				// 每段开始前清空上一段数据
				this.markerData = []
				this.path = []
				this.trailData = []
				
				await this.initMarker2(param)
				await this.getLine()
				// 回放开始时先标记最开始的起点城市（后续段的起点即上一段终点，已标记过）
				if (this.pathIndex === 0) {
					await this.initLabel(param)
				}
				
				if (this.markerData.length === 0) {
					console.warn('路径为空，无法移动')
					return
				}
				
				// 根据实际路线距离计算速度，使 marker 移动和 trail 回放同时结束
				let lineDistance = this.calcLineDistance(this.path) // 米
				this.segDistance = lineDistance
				let playRate = lineDistance / this.durationTime // 米/秒
				this.speed = playRate
				console.log('本段距离:', lineDistance.toFixed(2), 'm, playRate:', playRate.toFixed(2), 'm/s')
				
				await this.initTrail2(param, playRate)
				
				console.log("move移动中")
				console.log(this.markerData)
				this.marker.moveAlong({
					vehicle: {
						path: this.markerData,
						duration: this.durationTime*1000
					},
				}, {
					autoRotation: true,
				});
				this.trail.setData(this.trailData); //设置数据
			},
			// 初始化标记文本
			async initLabel(param,AIndex){
				return new Promise((resolve)=>{
					let that = this
					let index = this.pathIndex
					let len = param.path.length-1
					let posi = param.path[0]
					let name = param.endCity.name
					let labelId = 100+index
					if(AIndex){
						// 终点标记使用独立 id 区间，避免多段重复
						labelId = 200+index
						posi = param.path[len]
					}else{
						name = param.startCity.name
					}
					this.markerLabel = new TMap.MultiLabel({
						id:labelId,
						map:this.map,
						styles:{
							'label':new TMap.LabelStyle({
								color:'#fff',
								size:16,
								backgroundColor:'#00aaff',
								borderWidth:2,
								borderRadius:10,
								borderColor:"#fff",
								padding:'5px 10px',
								offset:{
									x:0,
									y:-50
								},
								
							})
						},
						geometries:[
							{
								id: "label",
								styleId: "label",
								position: new TMap.LatLng(posi.latitude, posi.longitude),
								content:name
							}
						]
					})
					resolve()
				})
			},
			
			getDistanceBetweenPoints(lat1, lng1, lat2, lng2) {
				// 将经纬度转换为弧度
				let toRadians = (degree) => degree * (Math.PI / 180);
				let R = 6371; // 地球半径（单位：千米）

				let dLat = toRadians(lat2 - lat1);
				let dLng = toRadians(lng2 - lng1);
				let a =
					Math.sin(dLat / 2) * Math.sin(dLat / 2) +
					Math.cos(toRadians(lat1)) *
					Math.cos(toRadians(lat2)) *
					Math.sin(dLng / 2) *
					Math.sin(dLng / 2);
				let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				return R * c; // 返回千米单位
			},
			calcLineDistance(path) {
				if (path.length < 2) return 0;
				let totalDistance = 0;
				for (let i = 1; i < path.length; i++) {
					let prev = path[i - 1];
					let curr = path[i];
					totalDistance += this.getDistanceBetweenPoints(
						prev[0], prev[1],
						curr[0], curr[1]
					);
				}
				return totalDistance * 1000;
			},
			async initTrail2(param, playRate) {
				return new Promise((resolve)=>{
					let that = this
					// 不同段使用渐变色，增强视觉层次
					const palette = ['#4FE3C1', '#5AC8FA', '#A78BFA', '#F472B6', '#FBBF24', '#34D399']
					const trailColor = param.lineColor || palette[this.pathIndex % palette.length]
					// 每段使用独立 Trail 图层，播放完毕后保留在地图上
					let trail = new TMap.visualization.Trail({
						pickStyle: function(item) {
							//轨迹图样式映射函数：更亮的高亮线 + 轻微发光
							return {
								width: 8,
								color: trailColor,
							};
						},
						showDuration: Infinity, //动画中轨迹点高亮的持续时间
						playTimes: 1,
						playRate: playRate,
						enableColorOffset: true
					}).addTo(this.map);
					this.trails.push(trail)
					this.trail = trail
					resolve()
				})
				
			},
			
			async initMarker2(param){
				return new Promise((resolve)=>{
					let that = this
					console.log("图层"+this.pathIndex)
					this.marker = new TMap.MultiMarker({
						id:this.pathIndex,
						map:this.map,
						styles:{
							"vehicle": new TMap.MarkerStyle({
								width: 50,
								height: 50,
								faceTo: "map",
								rotate: 180,
								src: param.vehicleUrl,
							}),
							"start":new TMap.MarkerStyle({
								width: 30,
								height: 30,
								
								src:Point,
							})
						},
						geometries: [{
								id: "vehicle",
								styleId: "vehicle",
								position: new TMap.LatLng(param.path[0].latitude, param.path[0].longitude),
							},
							{
								id: "start",
								styleId: "start",
								position: new TMap.LatLng(param.path[0].latitude, param.path[0].longitude),
							}
							
						],
					})
					// this.marker.add({
					// 	id:this.pathIndex,
					// 	styleId:`vehicle${this.pathIndex}`,
					// 	position: new TMap.LatLng(param.path[0].latitude, param.path[0].longitude),
						
					// })
					
					
					this.marker.on('moving', function(e) {
						if (e.vehicle) {
							that.roation = TMap.geometry.computeHeading(
								e.vehicle.passedLatLngs[e.vehicle.passedLatLngs.length - 2],
								e.vehicle.passedLatLngs[e.vehicle.passedLatLngs.length - 1]
							);
							that.position = TMap.geometry.computeDestination(that.marker.getGeometryById(
								'vehicle').position, that.roation, 60);
						}
						this.map.easeTo({
							center: that.position,
							rotation: e.vehicle.angle,
							zoom: that.mapZoom,
							pitch: 50,
						}, {
							duration: 500,
						});
					});
					this.marker.on("move_ended", function() {
						console.log("轨迹播放完毕")
						// await that.removePoint()
						that.markerData = []
						that.path = []
						
						that.marker.remove("vehicle")
						
						// 在本段终点位置补充 Point 图标（最后一个城市不会作为下一段起点，需在此添加）
						let endPoint = param.path[param.path.length-1]
						that.marker.add({
							id: "end",
							styleId: "start",
							position: new TMap.LatLng(endPoint.latitude, endPoint.longitude),
						})
						
						// 每抵达一个终点就添加该城市名称标记
						that.initLabel(param,true)
						// 到达提示弹出
						that.showArriveToast(param.endCity.name)
						
						let clen  = that.cityList.length
						if(that.pathIndex==clen-1){
							let len = param.path.length
							let endPosi = param.path[len-1]
							if(clen==1){
								that.allPoint.push(param.path[0])
								that.allPoint.push(endPosi)
							}else{
								that.allPoint.push(endPosi)
							}
							
							that.addDisPoint(endPosi)
							
							if(that.cityList[that.pathIndex].imgList.length==0){
								that.setAllpoint()
							}else{
								setTimeout(()=>{
									that.isShow = true
									that.imgList = that.cityList[that.pathIndex].imgList
									that.zoomOutToCity(param.endCity)
								},800)
							}
						}else{
							that.allPoint.push(param.path[0])
							if(that.cityList[that.pathIndex].imgList.length==0){
								that.pathIndex++
								that.startMove()
							}else{
								setTimeout(()=>{
									that.isShow = true
									that.imgList = that.cityList[that.pathIndex].imgList
									that.zoomOutToCity(param.endCity)
								},800)
							}
						}
						
					})
					// this.marker.remove("vehicle")
					resolve()
				})
			},
			setAllpoint(){
				let bounds = new TMap.LatLngBounds();
				this.allPoint.forEach(function(geometry) {
					// new TMap.LatLng(posi.latitude,posi.longitude)
				  // let latLng = geometry.position; // TMap.LatLng 对象
				  let latLng = new TMap.LatLng(geometry.latitude,geometry.longitude)
				  bounds.extend(latLng);
				});
				
				// 4. 调用 map.fitBounds，让地图自动调整视野以包含所有点
				this.map.fitBounds(bounds,{
					padding:20
				});
				this.isPlay = false
				// 延迟跳转，让用户看清完整路线
				setTimeout(()=>{
					this.backToMiniProgram()
				}, 2000)
			},
			async removePoint(){
				return new Promise((resolve)=>{
					// this.marker.remove([this.pathIndex])
					this.marker.remove(`vehicle${this.pathIndex}`)
					// this.marker.setGeometries([])
					resolve()
				})
				
			},
			/* ===== 地球旋转开场 ===== */
			// 动态加载 three.js（CDN），失败则直接跳过开场
			loadThree() {
				return new Promise((resolve, reject) => {
					if (window.THREE) { resolve(); return }
					const s = document.createElement('script')
					// 优先加载本地 three.js，失败再尝试 CDN
					s.src = 'lib/three.min.js'
					s.onload = resolve
					s.onerror = () => {
						const cdn = document.createElement('script')
						cdn.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js'
						cdn.onload = resolve
						cdn.onerror = reject
						document.head.appendChild(cdn)
					}
					document.head.appendChild(s)
				})
			},
			playGlobeIntro() {
				this.loadThree().then(() => {
					// canvas 需在 DOM 中存在才能初始化 WebGL
					this.$nextTick(() => {
						this.initGlobe()
					})
				}).catch(() => {
					this.finishGlobe()
				})
			},
			initGlobe() {
				const THREE = window.THREE
				const startCity = this.cityList[0].startCity
				const TARGET = { lat: startCity.latitude, lon: startCity.longitude }
				const DEG = Math.PI / 180
				const T_APPROACH = 3.0  // 地球旋转展示时长(s)
				const SPIN_TURNS = 1

				const clamp = (v, a, b) => Math.max(a, Math.min(b, v))
				const lerp = (a, b, t) => a + (b - a) * t
				const easeInOutCubic = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
				const easeInCubic = t => t * t * t
				const easeInOutQuart = t => t < .5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2

				// 经纬度 -> 与 THREE.SphereGeometry UV 贴图对齐的向量
				const latLonToVec3 = (lat, lon, r) => {
					const phi = (90 - lat) * DEG, theta = (lon + 180) * DEG
					return new THREE.Vector3(
						-r * Math.sin(phi) * Math.cos(theta),
						r * Math.cos(phi),
						r * Math.sin(phi) * Math.sin(theta))
				}
				// 使 (lat,lon) 朝向相机 (+Z) 的 y 轴旋转角
				const solveFacingY = (lat, lon) => {
					const v = latLonToVec3(lat, lon, 1)
					return Math.atan2(-v.x, v.z)
				}
				const yStart = solveFacingY(18, 105)
				const yEnd = solveFacingY(TARGET.lat, TARGET.lon)

				// CDN 贴图失败时的程序化地球贴图
				const proceduralEarthTex = () => {
					const c = document.createElement('canvas'); c.width = 1024; c.height = 512
					const g = c.getContext('2d')
					const grd = g.createLinearGradient(0, 0, 0, 512)
					grd.addColorStop(0, '#dff4ff'); grd.addColorStop(.12, '#0b3d77')
					grd.addColorStop(.5, '#0a2f5e'); grd.addColorStop(.88, '#0b3d77')
					grd.addColorStop(1, '#eafaff')
					g.fillStyle = grd; g.fillRect(0, 0, 1024, 512)
					for (let i = 0; i < 260; i++) {
						const x = Math.random() * 1024, y = 120 + Math.random() * 270, r = 8 + Math.random() * 46
						g.fillStyle = 'rgba(' + ((30 + Math.random() * 40) | 0) + ',' + ((90 + Math.random() * 60) | 0) + ',' + ((50 + Math.random() * 30) | 0) + ',.85)'
						g.beginPath(); g.ellipse(x, y, r, r * (.4 + Math.random() * .6), Math.random() * Math.PI, 0, Math.PI * 2); g.fill()
					}
					return new THREE.CanvasTexture(c)
				}
				const cloudTex = () => {
					const c = document.createElement('canvas'); c.width = 1024; c.height = 512
					const g = c.getContext('2d'); g.clearRect(0, 0, 1024, 512)
					// 减少云量与透明度，避免白雾感
					for (let i = 0; i < 200; i++) {
						const x = Math.random() * 1024, y = Math.random() * 512, r = 6 + Math.random() * 38
						const a = .03 + Math.random() * .12
						const rg = g.createRadialGradient(x, y, 0, x, y, r)
						rg.addColorStop(0, 'rgba(255,255,255,' + a + ')')
						rg.addColorStop(1, 'rgba(255,255,255,0)')
						g.fillStyle = rg; g.beginPath(); g.arc(x, y, r, 0, Math.PI * 2); g.fill()
					}
					return new THREE.CanvasTexture(c)
				}

				const canvas = document.getElementById('globeCanvas')
				if (!canvas) {
					console.warn('globeCanvas 不存在，跳过开场')
					this.finishGlobe()
					return
				}
				const renderer = new THREE.WebGLRenderer({ canvas, antialias: true })
				renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
				renderer.setSize(window.innerWidth, window.innerHeight)

				const scene = new THREE.Scene()
				const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, .01, 200)
				camera.position.set(0, 0, 5.0)

				// 星空
				const starGeo = new THREE.BufferGeometry(), N = 2600, pos = new Float32Array(N * 3)
				for (let i = 0; i < N; i++) {
					const r = 40 + Math.random() * 60, u = Math.random() * 2 - 1,
						th = Math.random() * Math.PI * 2, s = Math.sqrt(1 - u * u)
					pos[i * 3] = r * s * Math.cos(th); pos[i * 3 + 1] = r * u; pos[i * 3 + 2] = r * s * Math.sin(th)
				}
				starGeo.setAttribute('position', new THREE.BufferAttribute(pos, 3))
				const stars = new THREE.Points(starGeo, new THREE.PointsMaterial({
					color: 0xcfe8ff, size: .09, sizeAttenuation: true, transparent: true, opacity: .9 }))
				scene.add(stars)

				// 灯光
				// 降低光照强度，避免表面过曝发白
				const sunLight = new THREE.DirectionalLight(0xffffff, 0.9)
				sunLight.position.set(-6, 2.5, 4)
				scene.add(sunLight)
				scene.add(new THREE.AmbientLight(0x223348, .5))

				const earthGroup = new THREE.Group()
				scene.add(earthGroup)

				// 姿态关键帧
				const qStart = new THREE.Quaternion().setFromEuler(new THREE.Euler(.42, -.5, .06))
				const qEnd = new THREE.Quaternion().setFromEuler(new THREE.Euler(TARGET.lat * DEG, 0, 0))

				let earthMesh = null, cloudMesh = null, rafId = 0, t0 = 0
				const loop = (ts) => {
					rafId = requestAnimationFrame(loop)
					const t = (ts - t0) / 1000, p = clamp(t / T_APPROACH, 0, 1)
					// 相机推进：先巡航再俯冲
					const e = p < .58 ? easeInOutCubic(p / .58) * .5 : .5 + easeInCubic((p - .58) / .42) * .5
					camera.position.z = lerp(5.0, 1.34, e)
					// 姿态 + 自转
					earthGroup.quaternion.slerpQuaternions(qStart, qEnd, easeInOutCubic(p))
					const y = yStart + (yEnd + SPIN_TURNS * Math.PI * 2 - yStart) * easeInOutQuart(p)
					if (earthMesh) earthMesh.rotation.y = y
					if (cloudMesh) cloudMesh.rotation.y = y * 1.06 + t * .004
					stars.rotation.y = t * .004
					// 着陆前抖动
					if (p > .9) {
						const s = (p - .9) * .06
						camera.position.x = (Math.random() - .5) * s
						camera.position.y = (Math.random() - .5) * s
					}
					camera.lookAt(0, 0, 0)
					this.setGlobeHUD(p)
					renderer.render(scene, camera)
					if (p >= 1) {
						cancelAnimationFrame(rafId)
						this.finishGlobe()
					}
				}

				let done = false
				const build = (tex) => {
					if (done) return; done = true
					// 提升贴图清晰度：各向异性过滤 + sRGB 色彩
					tex.anisotropy = renderer.capabilities.getMaxAnisotropy()
					tex.encoding = THREE.sRGBEncoding
					renderer.outputEncoding = THREE.sRGBEncoding
					earthMesh = new THREE.Mesh(new THREE.SphereGeometry(1, 96, 96),
						new THREE.MeshLambertMaterial({ map: tex }))
					earthGroup.add(earthMesh)
					// 云层已去掉，避免白雾感
					// 大气层 —— 背面菲涅尔辉光
					const glow = new THREE.Mesh(new THREE.SphereGeometry(1.14, 64, 64),
						new THREE.ShaderMaterial({
							side: THREE.BackSide, transparent: true, blending: THREE.AdditiveBlending, depthWrite: false,
							vertexShader: 'varying vec3 vN;void main(){vN=normalize(normalMatrix*normal);' +
								'gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);}',
							fragmentShader: 'varying vec3 vN;void main(){float i=pow(.68-dot(vN,vec3(0.,0.,1.)),2.8);' +
								'gl_FragColor=vec4(.24,.72,1.,1.)*i*1.0;}'
						}))
					earthGroup.add(glow)
					t0 = performance.now() + 400
					rafId = requestAnimationFrame(loop)
				}
				const texLoader = new THREE.TextureLoader()
				texLoader.crossOrigin = 'anonymous'
				// 优先加载本地高清贴图（随包打包，秒加载）；失败再降级 CDN / 程序化贴图
				texLoader.load(EarthTex, build, undefined, () => {
					texLoader.load('https://unpkg.com/three-globe/example/img/earth-blue-marble.jpg',
						build, undefined, () => build(proceduralEarthTex()))
				})
				setTimeout(() => { if (!done) build(proceduralEarthTex()) }, 6000)

				// 供销毁/跳过时停止动画
				this._globe = {
					stop: () => cancelAnimationFrame(rafId),
					dispose: () => renderer.dispose()
				}
			},
			setGlobeHUD(p) {
				const lerp = (a, b, t) => a + (b - a) * t
				const easeInOutCubic = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
				const alt = Math.round(lerp(35786, 120, easeInOutCubic(p)))
				this.globeCoord = 'ALT ' + alt.toLocaleString() + ' KM · LEO'
				const cityName = this.cityList.length ? this.cityList[0].startCity.name : ''
				if (p < .3) this.globeStatus = '正在接近地球 <b>· APPROACHING EARTH</b>'
				else if (p < .62) this.globeStatus = '目标区域 <b>· 东亚 / EAST ASIA</b>'
				else if (p < .92) this.globeStatus = '锁定目标 <b>· ' + cityName + '</b>'
				else this.globeStatus = '再入大气层 <b>· 光速穿越启动</b>'
			},
			finishGlobe() {
				if (!this.showGlobe) return
				this.showGlobe = false
				if (this._globe) {
					this._globe.stop()
					this._globe.dispose()
					this._globe = null
				}
				// 地球淡出后触发云层掀开特效，轨迹回放同时开始（云掀开时地图已在动）
				this.isWarping = true
				setTimeout(() => {
					this.isWarping = false
				}, 1100)
				this.startMove()
			},
			skipGlobe() {
				this.finishGlobe()
			},
			async initMap() {
				console.log(this.cityList)
				let startPoint = this.cityList[0].startCity
				let center = new TMap.LatLng(startPoint.latitude, startPoint.longitude)
				this.map = new TMap.Map(document.getElementById('container'), {
					center: center, //设置地图中心点坐标
					zoom: 10, //设置地图缩放级别
					disableDefaultUI: true,
					pitch: 30, //设置俯仰角
					baseMap: {
						type: 'satellite', // 核心：设置为卫星底图
						features: ['base', 'road'] // 显示影像+路网
					}

				});
			}

		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.btn {
		position: absolute;
		padding: 10px;
		top: 50px;
		left: 50px;
		background-color: azure;
		z-index: 1000;
		pointer-events: auto;
	}

	/deep/ .rotate-circle {
		display: none;
	}

	/deep/ .tmap-zoom-control {
		display: none;
	}

	.Ccon {
		position: relative;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
	}

	#container {
		width: 100vw;
		height: 110vh;
		position: relative;
	}

	/* ===== 氛围遮罩 ===== */
	.vignette {
		position: absolute;
		left: 0;
		right: 0;
		height: 18vh;
		pointer-events: none;
		z-index: 5;
	}
	.vignette-top {
		top: 0;
		background: linear-gradient(180deg, rgba(6, 18, 30, 0.55), rgba(6, 18, 30, 0));
	}
	.vignette-bottom {
		bottom: 0;
		background: linear-gradient(0deg, rgba(6, 18, 30, 0.55), rgba(6, 18, 30, 0));
	}

	/* ===== 顶部行程进度 ===== */
	.journey-header {
		position: absolute;
		top: 24px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 20;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 12px;
		padding: 14px 28px 16px;
		border-radius: 18px;
		background: rgba(10, 24, 40, 0.42);
		backdrop-filter: blur(14px);
		-webkit-backdrop-filter: blur(14px);
		border: 1px solid rgba(255, 255, 255, 0.14);
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
	}
	.journey-title {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 14px;
		letter-spacing: 4px;
		color: rgba(255, 255, 255, 0.92);
		font-weight: 600;
	}
	.journey-icon {
		font-size: 15px;
		filter: drop-shadow(0 0 6px rgba(79, 227, 193, 0.8));
	}
	.journey-progress {
		display: flex;
		align-items: flex-start;
	}
	.progress-node {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		min-width: 64px;
	}
	.node-dot {
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.35);
		border: 2px solid rgba(255, 255, 255, 0.5);
		transition: all 0.4s ease;
		z-index: 2;
	}
	.node-dot.end {
		border-radius: 3px;
		transform: rotate(45deg);
	}
	.progress-node.done .node-dot {
		background: #4fe3c1;
		border-color: #4fe3c1;
		box-shadow: 0 0 10px rgba(79, 227, 193, 0.7);
	}
	.progress-node.active .node-dot {
		background: #ffd166;
		border-color: #ffd166;
		box-shadow: 0 0 12px rgba(255, 209, 102, 0.9);
		animation: pulse 1.4s ease-in-out infinite;
	}
	.node-name {
		margin-top: 6px;
		font-size: 11px;
		color: rgba(255, 255, 255, 0.55);
		white-space: nowrap;
		transition: color 0.4s ease;
	}
	.progress-node.done .node-name,
	.progress-node.active .node-name {
		color: #fff;
	}
	.node-line {
		position: absolute;
		top: 5px;
		left: calc(50% + 8px);
		width: calc(100% - 6px);
		height: 2px;
		background: rgba(255, 255, 255, 0.18);
		overflow: hidden;
	}
	.progress-node.done .node-line {
		background: linear-gradient(90deg, #4fe3c1, rgba(79, 227, 193, 0.6));
	}

	@keyframes pulse {
		0%, 100% { transform: scale(1); }
		50% { transform: scale(1.45); }
	}

	/* ===== 左下角行程卡片 ===== */
	.trip-card {
		position: absolute;
		left: 24px;
		bottom: 32px;
		z-index: 20;
		min-width: 220px;
		padding: 16px 20px;
		border-radius: 16px;
		background: rgba(10, 24, 40, 0.48);
		backdrop-filter: blur(14px);
		-webkit-backdrop-filter: blur(14px);
		border: 1px solid rgba(255, 255, 255, 0.14);
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.28);
		color: #fff;
	}
	.trip-card-tag {
		display: inline-block;
		font-size: 11px;
		letter-spacing: 1px;
		color: #4fe3c1;
		border: 1px solid rgba(79, 227, 193, 0.5);
		border-radius: 20px;
		padding: 3px 10px;
		margin-bottom: 12px;
	}
	.trip-route {
		display: flex;
		align-items: center;
		gap: 10px;
		font-size: 20px;
		font-weight: 700;
		letter-spacing: 1px;
	}
	.trip-arrow {
		position: relative;
		flex: 1;
		min-width: 36px;
		height: 2px;
		background: linear-gradient(90deg, rgba(79, 227, 193, 0.2), #4fe3c1);
		overflow: visible;
	}
	.trip-arrow::after {
		content: '';
		position: absolute;
		top: -1px;
		left: 0;
		width: 14px;
		height: 4px;
		border-radius: 4px;
		background: #fff;
		filter: blur(1px);
		animation: flow 1.2s linear infinite;
	}
	@keyframes flow {
		0% { left: 0; opacity: 0; }
		20% { opacity: 1; }
		80% { opacity: 1; }
		100% { left: calc(100% - 14px); opacity: 0; }
	}
	.trip-dest {
		color: #ffd166;
		animation: mystery 1.6s ease-in-out infinite;
	}
	@keyframes mystery {
		0%, 100% { opacity: 0.45; transform: scale(1); }
		50% { opacity: 1; transform: scale(1.15); }
	}
	.trip-arrow i {
		position: absolute;
		right: -1px;
		top: -4px;
		width: 0;
		height: 0;
		border-left: 8px solid #4fe3c1;
		border-top: 5px solid transparent;
		border-bottom: 5px solid transparent;
	}
	.trip-meta {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 12px;
		font-size: 12px;
		color: rgba(255, 255, 255, 0.65);
	}
	.trip-live {
		display: flex;
		align-items: center;
		gap: 6px;
		color: #ffd166;
	}
	.live-dot {
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background: #ffd166;
		animation: blink 1.2s ease-in-out infinite;
	}
	@keyframes blink {
		0%, 100% { opacity: 1; }
		50% { opacity: 0.25; }
	}

	/* 到达提示 */
	.arrive-toast {
		position: absolute;
		left: 50%;
		top: 40%;
		transform: translateX(-50%);
		z-index: 30;
		padding: 14px 28px;
		border-radius: 30px;
		background: rgba(10, 24, 40, 0.6);
		backdrop-filter: blur(10px);
		border: 1px solid rgba(79, 227, 193, 0.4);
		color: #fff;
		font-size: 18px;
		font-weight: 600;
		letter-spacing: 1px;
		box-shadow: 0 8px 32px rgba(0,0,0,0.3), 0 0 20px rgba(79, 227, 193, 0.2);
	}
	.arrive-pop-enter-active {
		transition: all 0.5s cubic-bezier(0.22, 1.4, 0.36, 1);
	}
	.arrive-pop-leave-active {
		transition: all 0.4s ease;
	}
	.arrive-pop-enter, .arrive-pop-leave-to {
		opacity: 0;
		transform: translateX(-50%) translateY(20px) scale(0.9);
	}

	/* 加载失败 */
	.track-error {
		position: absolute;
		inset: 0;
		z-index: 40;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(6, 18, 30, 0.7);
		backdrop-filter: blur(6px);
	}
	.error-box {
		padding: 20px 36px;
		border-radius: 14px;
		background: rgba(10, 24, 40, 0.8);
		border: 1px solid rgba(244, 114, 182, 0.4);
		color: #F472B6;
		font-size: 16px;
		letter-spacing: 1px;
	}

	/* 卡片切换动画 */
	.card-fade-enter-active {
		transition: all 0.5s cubic-bezier(0.22, 1.4, 0.36, 1);
	}
	.card-fade-leave-active {
		transition: all 0.3s ease;
	}
	.card-fade-enter, .card-fade-leave-to {
		opacity: 0;
		transform: translateY(18px) scale(0.95);
	}

	/* ===== 地球旋转开场 ===== */
	.globe-intro {
		position: absolute;
		inset: 0;
		z-index: 60;
		background: #000;
	}
	#globeCanvas {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		display: block;
	}
	.globe-vignette {
		position: absolute;
		inset: 0;
		pointer-events: none;
		background: radial-gradient(ellipse at center, transparent 55%, rgba(0, 0, 0, 0.55) 100%);
	}
	.globe-hud {
		position: absolute;
		inset: 0;
		pointer-events: none;
		font-family: ui-monospace, "SF Mono", "Cascadia Code", Menlo, Consolas, "PingFang SC", "Microsoft YaHei", monospace;
	}
	.hud-corner {
		position: absolute;
		width: 26px;
		height: 26px;
		border: 1px solid rgba(58, 226, 255, 0.35);
	}
	.hc-tl { top: 9vh; left: 4vw; border-right: none; border-bottom: none; }
	.hc-tr { top: 9vh; right: 4vw; border-left: none; border-bottom: none; }
	.hc-bl { bottom: 9vh; left: 4vw; border-right: none; border-top: none; }
	.hc-br { bottom: 9vh; right: 4vw; border-left: none; border-top: none; }
	.globe-hud-top {
		position: absolute;
		top: calc(9vh + 8px);
		left: calc(4vw + 40px);
		font-size: 11px;
		letter-spacing: 0.32em;
		color: rgba(240, 246, 255, 0.52);
	}
	.globe-hud-top b {
		color: #3ae2ff;
		font-weight: 600;
	}
	.globe-hud-status {
		position: absolute;
		bottom: calc(9vh + 10px);
		left: 50%;
		transform: translateX(-50%);
		font-size: 12px;
		letter-spacing: 0.24em;
		color: rgba(240, 246, 255, 0.52);
		white-space: nowrap;
	}
	/deep/ .globe-hud-status b {
		color: #f0f6ff;
		font-weight: 600;
	}
	.globe-hud-coord {
		position: absolute;
		bottom: calc(9vh + 10px);
		right: calc(4vw + 40px);
		font-size: 11px;
		letter-spacing: 0.18em;
		color: rgba(240, 246, 255, 0.25);
	}
	.globe-skip {
		position: absolute;
		top: calc(7vh + 18px);
		right: 4vw;
		z-index: 61;
		cursor: pointer;
		background: rgba(0, 0, 0, 0.35);
		border: 1px solid rgba(240, 246, 255, 0.22);
		color: rgba(240, 246, 255, 0.52);
		font-size: 11px;
		letter-spacing: 0.28em;
		text-indent: 0.28em;
		padding: 10px 18px;
		backdrop-filter: blur(6px);
		font-family: ui-monospace, "SF Mono", "Cascadia Code", Menlo, Consolas, "PingFang SC", "Microsoft YaHei", monospace;
		transition: color 0.25s, border-color 0.25s;
	}
	.globe-skip:hover {
		color: #f0f6ff;
		border-color: rgba(58, 226, 255, 0.35);
	}
	.globe-fade-leave-active {
		transition: opacity 0.8s ease;
	}
	.globe-fade-leave-to {
		opacity: 0;
	}

	/* ===== 地球→地图 云层掀开过渡特效 ===== */
	.cloud-wipe {
		position: absolute;
		inset: 0;
		z-index: 55;
		pointer-events: none;
		overflow: hidden;
	}
	.cloud-piece {
		position: absolute;
		width: 110vmax;
		height: 110vmax;
		border-radius: 50%;
		/* 浓云阶段：中心厚实，边缘柔和 */
		background: radial-gradient(circle at center,
			rgba(255, 255, 255, 1) 0%,
			rgba(245, 250, 255, 0.95) 30%,
			rgba(225, 240, 252, 0.7) 55%,
			rgba(205, 228, 248, 0.35) 72%,
			transparent 85%);
		filter: blur(18px);
		opacity: 0;
	}
	/* 中心云团：先凝结变厚铺满，再膨胀变薄消散 */
	.cloud-c {
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%) scale(0.5);
		animation: cloudCenter 1.1s cubic-bezier(0.4, 0, 0.2, 1) forwards;
	}
	/* 四角云团：先凝结，再向角落掀开，越飞越薄 */
	.cloud-tl { left: 18%; top: 22%; --dx: -60vw; --dy: -40vh; }
	.cloud-tr { left: 82%; top: 22%; --dx: 60vw;  --dy: -40vh; }
	.cloud-bl { left: 18%; top: 78%; --dx: -60vw; --dy: 40vh; }
	.cloud-br { left: 82%; top: 78%; --dx: 60vw;  --dy: 40vh; }
	.cloud-tl, .cloud-tr, .cloud-bl, .cloud-br {
		transform: translate(-50%, -50%) scale(0.55);
		animation: cloudFly 1.1s cubic-bezier(0.4, 0, 0.2, 1) forwards;
	}
	.cloud-tr { animation-delay: 0.08s; }
	.cloud-bl { animation-delay: 0.14s; }
	.cloud-br { animation-delay: 0.2s; }
	@keyframes cloudCenter {
		/* 凝结：快速变厚 */
		0%   { opacity: 0;   transform: translate(-50%, -50%) scale(0.5);  filter: blur(30px); }
		25%  { opacity: 1;   transform: translate(-50%, -50%) scale(0.95); filter: blur(16px); }
		/* 掀开：膨胀拉伸，越变越薄 */
		60%  { opacity: 0.55; filter: blur(24px); }
		100% { opacity: 0;   transform: translate(-50%, -50%) scale(1.5);  filter: blur(40px); }
	}
	@keyframes cloudFly {
		/* 凝结：快速变厚 */
		0%   { opacity: 0;   transform: translate(-50%, -50%) scale(0.55); filter: blur(30px); }
		25%  { opacity: 1;   transform: translate(-50%, -50%) scale(0.9);  filter: blur(16px); }
		/* 掀开飞散：变大的同时越来越薄 */
		60%  { opacity: 0.5; filter: blur(26px); }
		100% { opacity: 0;   transform: translate(calc(-50% + var(--dx)), calc(-50% + var(--dy))) scale(1.25); filter: blur(46px); }
	}
</style>